export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f0a6556faf5b26c09a6cb378412040ce5a868c40a&name=fetchTypeahead!'